module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.378/img/iphone-frame.png"